(function () {
  function ready(fn){ document.readyState!=="loading" ? fn() : document.addEventListener("DOMContentLoaded",fn); }

  ready(function(){
    document.querySelectorAll(".ds-wrap[data-product-id]").forEach(function(root){
      var btn   = root.querySelector(".ds-btn");
      var note  = root.querySelector(".ds-note");
      var pid   = root.getAttribute("data-product-id");
      var tpl   = document.getElementById("ds-html-"+pid);

      var logo  = root.getAttribute("data-logo");
      var title = root.getAttribute("data-title") || "";
      var photo = root.getAttribute("data-photo") || "";
      var sku   = root.getAttribute("data-sku")   || "";
      var brand = root.getAttribute("data-brand") || "";

      var descTpl  = document.getElementById("ds-desc-"+pid);
      var descHtml = descTpl ? (descTpl.innerHTML || "").trim() : "";

      if(!btn || !tpl) return;

      btn.addEventListener("click", async function(){
        try{
          var innerHtml = (tpl.innerHTML || "").trim();
          if (!innerHtml) { if (note) note.textContent = "Kein Datenblatt-Inhalt vorhanden."; return; }

          var css =
            "@page{size:A4;margin:10mm}" +
            "html,body{margin:0;padding:0;background:#fff;color:#111;font:12px/1.45 Arial,Helvetica,sans-serif}" +
            "*{-webkit-print-color-adjust:exact;print-color-adjust:exact;box-sizing:border-box}" +
            "#page{position:relative;width:190mm;height:277mm;margin:0 auto;background:#fff;padding:6mm 15mm 15mm 15mm}" +

            /* HEADER: Logo → Titel → HERO-Zeile */
            "#header{position:absolute;top:6mm;left:15mm;right:15mm;display:block}" +
            "#logo{display:block;width:50mm;height:auto}" +
            "#product-title{margin:20mm 0 0 0;font-size:4.5mm;font-weight:600;line-height:1.25}" +

            /* HERO: Foto links (leicht nach rechts versetzt) + Info daneben */
            "#hero{display:flex;align-items:flex-start;gap:40mm;margin-top:10mm}" +
            "#product-photo{display:block;max-width:50mm;height:auto;object-fit:contain;flex:0 0 auto;margin-left:3mm}" +
            "#info{flex:0 1 85mm;max-width:85mm}" +
            "#info h2{margin:0 0 4mm 0;font-size:4.2mm;font-weight:600;text-align:left}" +
            "#info .line{display:flex;gap:2mm;margin:0 0 2.5mm 0;font-size:3.8mm}" +
            "#info .label{min-width:28mm;font-weight:600;color:#333}" +

            /* DETAILS: Beschreibung + Spezifikationen nebeneinander, gleiche Höhe */
            "#details{display:flex;align-items:flex-start;gap:12mm;margin-top:20mm}" +
            "#desc-col{flex:1 1 55%}" +
            "#specs-col{flex:1 1 45%}" +

            /* Beschreibung (kleiner) */
            "#description-title{margin:0 0 4mm 0;font-size:4.6mm;font-weight:600}" +
            "#description-full{margin:0;font-size:3.0mm;line-height:1.55;text-align:left}" +

            /* Spezifikationen (links, volle Spaltenbreite) */
            "#spec-heading{margin:0 0 5mm 0;font-size:4.6mm;font-weight:600;text-transform:none;text-align:left}" +
            "#spec-table{margin:0;text-align:left}" +
            "#spec-table table{width:100%;border-collapse:collapse}" +
            "#spec-table td,#spec-table th{padding:2.5mm 3mm;vertical-align:top;border:0.2mm solid #ddd}";

          // Logo (SVG → Data-URL)
          var logoTag = "";
          if (logo) {
            if (/\.svg(\?|$)/i.test(logo)) {
              try {
                const svgTxt = await fetch(logo, {mode:"cors"}).then(r => r.ok ? r.text() : "");
                if (svgTxt) {
                  const dataUrl = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgTxt.replace(/<\\?xml[^>]*>/i,"").trim());
                  logoTag = "<img id='logo' src='"+ dataUrl +"' alt='Logo'/>";
                }
              } catch(e){}
            }
            if (!logoTag) logoTag = "<img id='logo' src='"+ enc(logo) +"' alt='Logo'/>";
          }

          var titleTag = title ? "<div id='product-title'>"+ enc(title) +"</div>" : "";
          var photoTag = photo ? "<img id='product-photo' src='"+ enc(photo) +"' alt='"+ enc(title || "Produktfoto") +"'/>" : "";

          var infoHtml = "<div id='info'><h2>Informationen</h2>";
          if (sku)   infoHtml += "<div class='line'><span class='label'>Artikelnummer:</span><span class='value'>"+ enc(sku) +"</span></div>";
          if (brand) infoHtml += "<div class='line'><span class='label'>Marke:</span><span class='value'>"+ enc(brand) +"</span></div>";
          infoHtml += "</div>";

          var heroTag = "<div id='hero'>" + (photoTag || "") + infoHtml + "</div>";

          // DETAILS: zwei Spalten (Beschreibung links, Spezifikationen rechts)
          var descCol = descHtml
            ? "<div id='desc-col'><h2 id='description-title'>Beschreibung</h2><div id='description-full'>"+ descHtml +"</div></div>"
            : "";
          var specsCol =
            "<div id='specs-col'>" +
              "<h1 id='spec-heading'>Spezifikationen</h1>" +
              "<div id='spec-table'>"+ innerHtml +"</div>" +
            "</div>";

          var detailsBlock = "<div id='details'>" + descCol + specsCol + "</div>";

          var html =
            "<!doctype html><html lang='de'><head><meta charset='utf-8'><title>Datenblatt</title>" +
            "<style>"+ css +"</style></head><body>" +
            "<div id='page'>" +
              "<div id='header'>" + (logoTag || "") + titleTag + heroTag + detailsBlock + "</div>" +
            "</div>" +
            "</body></html>";

          var w = window.open("", "_blank");
          if(!w){ if(note) note.textContent = "Pop-up blockiert. Bitte Pop-ups erlauben."; return; }
          w.document.open(); w.document.write(html); w.document.close();

          await waitForImages(w.document);
          try { if (w.document.fonts && w.document.fonts.ready) await w.document.fonts.ready; } catch(e){}

          w.focus();
          w.onafterprint = function(){ try{ w.close(); }catch(e){} };
          w.print();
        }catch(e){
          console.error(e);
          if (note) note.textContent = "PDF-Erstellung fehlgeschlagen.";
        }
      });
    });
  });

  function waitForImages(doc){
    var imgs = Array.prototype.slice.call(doc.images || []);
    if (!imgs.length) return Promise.resolve();
    return Promise.all(imgs.map(function(img){
      if (img.complete && img.naturalWidth) return Promise.resolve();
      if (img.decode) return img.decode().catch(function(){}); // Safari-Fix
      return new Promise(function(res){ img.onload = img.onerror = function(){ res(); }; });
    }));
  }

  function enc(s){
    return String(s).replace(/["'<>&]/g, m => ({'"':"&quot;","'":"&#39;","<":"&lt;",">":"&amp;"})[m]);
  }
})();
